import { render, staticRenderFns } from "./AbsencesList.vue?vue&type=template&id=2e979ac9&scoped=true&lang=pug&"
import script from "./AbsencesList.vue?vue&type=script&lang=ts&"
export * from "./AbsencesList.vue?vue&type=script&lang=ts&"
import style0 from "./AbsencesList.vue?vue&type=style&index=0&id=2e979ac9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e979ac9",
  null
  
)

export default component.exports